export default __webpack_public_path__ + "static/media/successbg.70ed3708.png";